import { h, Component, Host, Element } from "@stencil/core";
// import { InitLogging } from "../../../decorators/init-logging";
//import { isSafari } from "../../../utils/device-helper";
@Component({
  tag: "eon-ui-grid-control-column",
  styleUrl: "grid-control-column.scss",
  shadow: false
})
export class GridControlColumn {
  // @InitLogging() sentryTransaction;

  @Element() hostElement: HTMLEonUiGridControlColumnElement;

  render() {
    return <Host></Host>;
  }
}
